import { IBasic, ICompany } from "../common/CommonTypes";
import { IMedium } from "./rohrgefuehrteMedien/components/request/RohrgefuehrteMedienRequestTypes";

export const AntragstellerFirmaOPSConsts: ICompany[] = [
  {
    Id: 1,
    Key: "Archroma",
    Name: "Archroma Germany GmbH",
    IstISG: false
  },
  {
    Id: 2,
    Key: "Clariant",
    Name: "Clariant Produkte (Deutschland) GmbH",
    IstISG: false
  },
  {
    Id: 3,
    Key: "Dyneon",
    Name: "Dyneon GmbH",
    IstISG: false
  },
  {
    Id: 4,
    Key: "Global Amines",
    Name: "Global Amines Germany GmbH",
    IstISG: false
  },
  {
    Id: 5,
    Key: "InfraServ Gendorf",
    Name: "Infraserv GmbH & Co Gendorf KG",
    IstISG: true
  },
  {
    Id: 6,
    Key: "InfraServ Gendorf Technik",
    Name: "InfraServ Gendorf Technik GmbH",
    IstISG: true
  },
  {
    Id: 7,
    Key: "InfraServ Gendorf Netze",
    Name: "InfraServ Gendorf Netze GmbH",
    IstISG: true
  },
  {
    Id: 8,
    Key: "Bildungsakademie",
    Name: "Bildungsakademie Inn-Salzach",
    IstISG: true
  },
  {
    Id: 9,
    Key: "Klöckner Pentaplast",
    Name: "Klöckner Pentaplast GmbH",
    IstISG: false
  },
  {
    Id: 10,
    Key: "Linde",
    Name: "Linde Gas Produktionsgesellschaft mbH & Co. KG",
    IstISG: false
  },
  {
    Id: 11,
    Key: "Vinnolit",
    Name: "Vinnolit GmbH & Co. KG",
    IstISG: false
  },
  {
    Id: 12,
    Key: "W.L. Gore",
    Name: "W. L. Gore & Associates GmbH",
    IstISG: false
  },
  {
    Id: 13,
    Key: "GTK",
    Name: "Gummitechnik Kreißler GmbH",
    IstISG: false
  }
]

export const MediumOPSConsts: IMedium[] = [
  {
    "Id": 1,
    "Medium": "Argon flüssig",
    "Normaldruck": 4,
    "Aggregatszustand": "flüssig",
    "MediumKurzzeichen": "LAR",
    "unit": "m³"
  },
  {
    "Id": 2,
    "Medium": "Argon gasförmig",
    "Normaldruck": 12,
    "Aggregatszustand": "gasförmig",
    "MediumKurzzeichen": "LAR",
    "unit": "m³/h"
  },
  {
    "Id": 3,
    "Medium": "Dampf, 11 bar ",
    "Normaldruck": 11,
    "Aggregatszustand": "gasförmig",
    "MediumKurzzeichen": "ST11",
    "unit": "t/h"
  },
  {
    "Id": 4,
    "Medium": "Dampf, 20 bar (MD)",
    "Normaldruck": 20,
    "Aggregatszustand": "gasförmig",
    "MediumKurzzeichen": "STM",
    "unit": "t/h"
  },
  {
    "Id": 5,
    "Medium": "Dampf, 4 bar (ND)",
    "Normaldruck": 39,
    "Aggregatszustand": "gasförmig",
    "MediumKurzzeichen": "STL",
    "unit": "t/h"
  },
  {
    "Id": 6,
    "Medium": "Dampf, 40 bar ",
    "Normaldruck": 35,
    "Aggregatszustand": "gasförmig",
    "MediumKurzzeichen": "STH40",
    "unit": "t/h"
  },
  {
    "Id": 7,
    "Medium": "Kondensat",
    "Normaldruck": null,
    "Aggregatszustand": "flüssig",
    "MediumKurzzeichen": "CPL",
    "unit": "m³/h"
  },
  {
    "Id": 8,
    "Medium": "Erdgas",
    "Normaldruck": 6,
    "Aggregatszustand": "gasförmig",
    "MediumKurzzeichen": "GN",
    "unit": "Nm³/h"
  },
  {
    "Id": 9,
    "Medium": "HD-Stickstoff, 30 bar Schiene",
    "Normaldruck": 29,
    "Aggregatszustand": "gasförmig",
    "MediumKurzzeichen": "NH",
    "unit": "Nm³/h"
  },
  {
    "Id": 10,
    "Medium": "ND-Stickstoff, 6 bar Schiene",
    "Normaldruck": 57,
    "Aggregatszustand": "gasförmig",
    "MediumKurzzeichen": "NM",
    "unit": "Nm³/h"
  },
  {
    "Id": 11,
    "Medium": "Stickstoff unrein",
    "Normaldruck": 55,
    "Aggregatszustand": "gasförmig",
    "MediumKurzzeichen": "NU",
    "unit": "Nm³/h"
  },
  {
    "Id": 12,
    "Medium": "Sauerstoff, 12 bar Schiene",
    "Normaldruck": 11,
    "Aggregatszustand": "gasförmig",
    "MediumKurzzeichen": "O12",
    "unit": "Nm³/h"
  },
  {
    "Id": 13,
    "Medium": "Sauerstoff, 18 bar Schiene",
    "Normaldruck": 17,
    "Aggregatszustand": "gasförmig",
    "MediumKurzzeichen": "O18",
    "unit": "Nm³/h"
  },
  {
    "Id": 14,
    "Medium": "Sauerstoff, 28 bar Schiene",
    "Normaldruck": 27,
    "Aggregatszustand": "gasförmig",
    "MediumKurzzeichen": "O28",
    "unit": "Nm³/h"
  },
  {
    "Id": 15,
    "Medium": "3,5 bar Druckluft",
    "Normaldruck": 35,
    "Aggregatszustand": "gasförmig",
    "MediumKurzzeichen": "AIP",
    "unit": "Nm³/h"
  },
  {
    "Id": 16,
    "Medium": "6 bar Druckluft",
    "Normaldruck": 55,
    "Aggregatszustand": "gasförmig",
    "MediumKurzzeichen": "AIP",
    "unit": "Nm³/h"
  },
  {
    "Id": 17,
    "Medium": "MSR-Luft 30 bar",
    "Normaldruck": 29,
    "Aggregatszustand": "gasförmig",
    "MediumKurzzeichen": "AII30",
    "unit": "Nm³/h"
  },
  {
    "Id": 18,
    "Medium": "MSR-Luft 6 bar",
    "Normaldruck": 55,
    "Aggregatszustand": "gasförmig",
    "MediumKurzzeichen": "AII6",
    "unit": "Nm³/h"
  },
  {
    "Id": 19,
    "Medium": "Rückkühlwasser",
    "Normaldruck": 53,
    "Aggregatszustand": "flüssig",
    "MediumKurzzeichen": "WCR",
    "unit": "m³/h"
  },
  {
    "Id": 20,
    "Medium": "Trinkwasser (oberes Werksnetz)",
    "Normaldruck": 6,
    "Aggregatszustand": "flüssig",
    "MediumKurzzeichen": "WD",
    "unit": "m³/h"
  },
  {
    "Id": 21,
    "Medium": "Trinkwasser (unteres Werksnetz)",
    "Normaldruck": 45,
    "Aggregatszustand": "flüssig",
    "MediumKurzzeichen": "WD",
    "unit": "m³/h"
  },
  {
    "Id": 22,
    "Medium": "VE-Wasser (oberes Werksnetz)",
    "Normaldruck": 55,
    "Aggregatszustand": "flüssig",
    "MediumKurzzeichen": "WDV",
    "unit": "m³/h"
  },
  {
    "Id": 23,
    "Medium": "VE-Wasser (unteres Werksnetz)",
    "Normaldruck": 75,
    "Aggregatszustand": "flüssig",
    "MediumKurzzeichen": "WDV",
    "unit": "m³/h"
  },
  {
    "Id": 24,
    "Medium": "Werkswasser (oberes Werksnetz)",
    "Normaldruck": 55,
    "Aggregatszustand": "flüssig",
    "MediumKurzzeichen": "WWBF",
    "unit": "m³/h"
  },
  {
    "Id": 25,
    "Medium": "Werkswasser (unteres Werksnetz)",
    "Normaldruck": 75,
    "Aggregatszustand": "flüssig",
    "MediumKurzzeichen": "WWBF",
    "unit": "m³/h"
  }
];

export const SpannungsebeneOPSConsts: IBasic[] = [
  { Id: 1, Key: "400V" },
  { Id: 2, Key: "500V" },
  { Id: 3, Key: "690V" },
  { Id: 4, Key: "6kV" },
  { Id: 5, Key: "30kV" },
];
